import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Video = createReactComponent("Video", ["svg", defaultAttributes, [["polygon", {
  points: "23 7 16 12 23 17 23 7",
  key: "1b60zo"
}], ["rect", {
  x: "1",
  y: "5",
  width: "15",
  height: "14",
  rx: "2",
  ry: "2",
  key: "cvl3lu"
}]]]);
export default Video;